import React from 'react';
import classNames from 'classnames/bind';
import VisibilitySensor from 'react-visibility-sensor';

import styles from './closingDoorStyles';

import Icon from 'buyside/components/presentation/Icon/icon';

import ClosedDoorIcon from 'SVGs/closed_door';

const cx = classNames.bind(styles);

class ClosingDoor extends React.Component {
  constructor() {
    super();
    this.state = { transition: false };
    this.onScreen = this.onScreen.bind(this);
  }

  onScreen(visible) {
    if (visible) this.setState({ transition: true });
  }

  render() {
    const iconClass = cx({
      closedDoor: true,
      isTriggered: this.state.transition
    });
    return (
      <VisibilitySensor onChange={this.onScreen} scrollCheck scrollThrottle={100}>
        <section className={styles.closedDoorSection}>
          <span className={styles.closedDoorFrame}>
            <Icon type={ClosedDoorIcon} style={iconClass} />
          </span>
          {this.props.message}
        </section>
      </VisibilitySensor>
    );
  }
}

export default ClosingDoor;
